
<main>
    <div class="main-page-wrapper overflow-hidden">
      <app-header></app-header>
      <router-outlet></router-outlet>
    </div>
</main>
<ngb-toast class="fixed_message" *ngIf="isAlertShow" [autohide]="true" (hide)="isAlertShow = false"
            [delay]="5000" [class]="(alert_type == 'success') ? 'bg-success text-light' : 'bg-danger text-light'">
    {{message}}
</ngb-toast>

<div *ngIf="loader"  class="loader-wrap">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>